<template>
  <div>
    <v-container>
      <h1>{{ title }}</h1>
      <v-row>
        <v-col cols="12" xs="12" md="4" sm="6">
          <v-text-field
            label="No of Days"
            type="number"
            v-model="model.silNoOfDays"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" md="4" sm="6">
          <v-text-field
            label="Divisor"
            type="number"
            v-model="model.silDivisor"
          ></v-text-field>
        </v-col>
      </v-row>
      <pay-loc-selection
        v-model="selected"
        :headers="headers"
        :showDense="false"
        :showSelect="true"
        :key="componentKey"
      ></pay-loc-selection>
      <v-row>
        <v-col>
          <v-btn color="success" @click.stop="apply" :loading="loading"
            >Apply</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import PayLocSelection from "../../setup/general/payroll-location/NewSelection.vue";
import { parseNumber } from "../../../validation/validation.js";
export default {
  data: () => ({
    title: "Utility - Payroll Location SIL",
    selected: [],
    model: {},
    headers: [
      {
        text: "",
        align: "left",
        sortable: false,
        value: "action",
      },
      {
        text: "Loc Id",
        align: "left",
        //sortable: false,
        value: "locId",
      },
      {
        text: "Location Name",
        align: "left",
        //sortable: false,
        value: "locName",
      },
      {
        text: "No of Days",
        align: "left",
        //sortable: false,
        value: "silNoOfDays",
      },
      {
        text: "Divisor",
        align: "left",
        //sortable: false,
        value: "silDivisor",
      },
    ],
    loading: false,
    componentKey: 0,
  }),
  computed: {
    payLoc() {
      return this.selected.join(",");
    },
  },
  components: {
    PayLocSelection,
  },
  methods: {
    apply() {
      this.loading = true;
      this.model.silNoOfDays = parseNumber(this.model.silNoOfDays);
      this.model.silDivisor = parseNumber(this.model.silDivisor);

      this.$axios
        .post(`/api/payrollLocation/sil`, {
          ...this.model,
          LocIDs: this.payLoc,
        })
        .then(({ data }) => {
          this.reset();
          this.$toast.success(data.message);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reset() {
      this.componentKey += 1;
      this.model = {};
      this.selected = [];
    },
  },
};
</script>
